"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const core_1 = require("@angular/core");
const script_1 = require("../../../@inax/script");
let ScriptViewerComponent = class ScriptViewerComponent {
    constructor(_inaxScript) {
        this._inaxScript = _inaxScript;
        this.scriptUnit = "ScriptTest";
        this.functionName = "InvokeTest";
    }
    ngOnInit() {
    }
    onExecute() {
        try {
            this._inaxScript.invokeInClientContext(this.scriptUnit, this.functionName, []).subscribe((result) => {
                if (result.Event != null) {
                    console.log(`changed ${result.Event.Timestamp}`);
                    this.lastChange = result.Event.Timestamp;
                }
                if (result.IsFinished) {
                    console.log("finished");
                }
            });
        }
        catch (error) {
            console.error(error);
        }
    }
};
ScriptViewerComponent = __decorate([
    core_1.Component({
        selector: 'script-viewer',
        templateUrl: 'app/components/scriptviewer/scriptviewer.component.html',
        styleUrls: ['app/components/scriptviewer/scriptviewer.component.css']
    }),
    __metadata("design:paramtypes", [script_1.InaxScriptService])
], ScriptViewerComponent);
exports.ScriptViewerComponent = ScriptViewerComponent;
